import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import _has from 'lodash/has';
import ClassNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
// import Colors from 'utils/colors';
import { fallbackImage } from 'utils/stringUtils';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const styles = theme => ({
  image: {
    height: 147,
    maxWidth: '100%',
    objectFit: 'contain',
    [theme.breakpoints.down('750')]: {
      marginBottom: 15,
      marginTop: 15,
    },
  },
  bigImage: {
    height: 283,
  },
  appImage: {
    height: 120,
    width: 120,
    border: '1px solid #E9ECED',
    borderRadius: 24,
    [theme.breakpoints.down('750')]: {
      marginTop: 30,
    },
  },
  podcastImage: {
    height: 120,
  },
  readImage: {
    height: 146,
  },
  eventImage: {
    height: 146,
  },
  mobileImage: {
    marginTop: 0,
    marginBottom: 0,
  },
  bookImageMobile: {
    height: 135,
  },
  orgImageMobile: {
    height: 135,
  },
  containImage: {
    objectFit: 'contain',
  },
});
/* eslint-disable */
function ResourceImage({ file, classes, type, isMobile, isBig }) {
  let ImageSrc = _isEmpty(file)
    ? fallbackImage
    : _has(file, 'url')
    ? file.url
    : file;
  if (ImageSrc.includes('.crediblemind.com')) {
    ImageSrc = fallbackImage;
  }
  return (
    <LazyLoadImage
      effect="blur"
      src={ImageSrc}
      onError={e => {
        e.target.src = fallbackImage;
      }}
      className={ClassNames(
        classes.image,
        type === 'app' ? classes.appImage : null,
        type === 'podcast' ? classes.podcastImage : null,
        type === 'article' ? classes.readImage : null,
        type === 'event' ? classes.eventImage : null,
        isMobile ? classes.mobileImage : null,
        type === 'book' && isMobile ? classes.bookImageMobile : null,
        type === 'organization' && isMobile ? classes.orgImageMobile : null,
        type === 'organization' && classes.containImage,
        isBig ? classes.bigImage : null,
      )}
      alt={type}
    />
  );
}

ResourceImage.propTypes = {
  file: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  classes: PropTypes.object,
  type: PropTypes.string,
  isMobile: PropTypes.bool,
  isBig: PropTypes.bool,
};

export default withStyles(styles)(ResourceImage);
